export default "__VITE_ASSET__BrsUWukj__"